import { useState, useMemo, useCallback } from "react";
import { toast } from "sonner";
import { getLake } from "../../lib/sampleLake";
import { exportSnapshot } from "../../lib/exportSnapshot";

export const useSampleMapState = () => {
  const [layer, setLayerState] = useState("depth");
  const [compare, setCompare] = useState(false);
  const [split, setSplit] = useState(0.5);
  const [showTransects, setShowTransects] = useState(false);
  const [unit, setUnit] = useState("ft");
  const [hover, setHover] = useState(null);
  const [points, setPoints] = useState([]);
  const [exporting, setExporting] = useState(false);
  const stats = useMemo(() => getLake().stats, []);

  const setLayer = (l) => { setLayerState(l); setCompare(false); };
  const toggleCompare = () => {
    if (!compare) setLayerState("vegetation");
    setCompare((c) => !c);
  };
  const clearPoints = () => setPoints([]);
  const onPick = useCallback((p) => setPoints((prev) => (prev.length >= 2 ? [p] : [...prev, p])), []);

  const onExport = async () => {
    setExporting(true);
    try {
      const name = await exportSnapshot({ layer, showTransects, points, unit, compare, split });
      toast.success("Map snapshot downloaded", { description: name });
    } catch {
      toast.error("Could not export the map. Please try again.");
    } finally {
      setExporting(false);
    }
  };

  return {
    layer, setLayer, compare, toggleCompare, split, setSplit, showTransects, setShowTransects,
    unit, setUnit, hover, setHover, points, clearPoints, onPick, exporting, onExport, stats,
  };
};
